module.exports = __webpack_public_path__ + "637ad34b273d109fb6df15776f5a9fcf.svg";